export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.tagline': 'Find Products, Sellers & Guides in One Place',
  'nav.home': 'Home',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.qc': 'QC Center',
  'nav.shipping': 'Shipping',
  'nav.reviews': 'Reviews',
  'nav.safety': 'Safety',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'lang.pt': 'Português',
  'lang.de': 'Deutsch',
  'lang.en': 'English',
  'cta.explore': 'Explore CSSBuy Spreadsheet',
  'cta.visitMain': 'Visit Main Website',
  'cta.buyNow': 'Buy It Now',
  'cta.readMore': 'Read More',
  'cta.viewAll': 'View All',
  'cta.search': 'Search',
  'footer.disclaimer': 'This website is an independent informational resource and is not necessarily affiliated with CSSBuy.',
  'footer.copyright': '© 2026 CSSBuy Spreadsheet. All rights reserved.',
  'footer.links': 'Links',
  'footer.resources': 'Resources',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  'footer.editorial': 'Editorial Policy',
  'footer.sitemap': 'Sitemap',
  'hero.title': 'CSSBuy Spreadsheet: Find Products, Sellers & Guides in One Place',
  'hero.subtitle': 'Explore an organized collection of CSSBuy spreadsheets, products, sellers, categories and practical guides to research better, compare options and understand each step of your purchase.',
  'hero.trust': 'Organized resources • Updated guides • Multi-language support',
  'search.placeholder': 'Search products, sellers, categories or keywords...',
  'search.popular': 'Popular:',
  'categories.title': 'Explore Popular Categories',
  'categories.subtitle': 'Find organized resources by category to make your research faster and simpler.',
  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies/Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants/Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear/Underpants',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',
  'spreadsheet.title': 'Why Use a CSSBuy Spreadsheet?',
  'spreadsheet.desc': 'A well-organized spreadsheet can help you find products and sellers more easily, compare information and reduce time spent researching different sources.',
  'spreadsheet.faster': 'Faster Search',
  'spreadsheet.fasterDesc': 'Find resources by product, category or seller.',
  'spreadsheet.organized': 'Everything Organized',
  'spreadsheet.organizedDesc': 'Check information in a simple and easy-to-navigate structure.',
  'spreadsheet.context': 'More Context',
  'spreadsheet.contextDesc': 'Combine spreadsheets with QC guides, sellers and shipping.',
  'guides.title': 'Everything You Need Before Buying',
  'guides.desc': 'Learn how to research products, evaluate sellers, analyze QC photos and consider different shipping options.',
  'guides.howToUse': 'How to Use CSSBuy Spreadsheet',
  'guides.evaluateSellers': 'How to Evaluate Sellers',
  'guides.qcPhotos': 'How to Analyze QC Photos',
  'guides.shipping': 'How to Understand Shipping',
  'safety.title': 'Safety First',
  'safety.desc': 'Always verify links, sources and information before buying. Never share your password or personal data with unknown pages. Be careful with offers, coupons and unverified sellers.',
  'commercial.title': 'Researching CSSBuy? Start with the Right Information.',
  'commercial.review': 'CSSBuy Review',
  'commercial.shipping': 'CSSBuy Shipping Cost',
  'commercial.coupon': 'CSSBuy Coupon',
  'commercial.discount': 'CSSBuy Discount Code',
  'commercial.warehouse': 'CSSBuy Warehouse',
  'commercial.legit': 'Is CSSBuy Legit?',
  'finalCta.title': 'Ready to Start Your Research?',
  'finalCta.desc': 'Explore the CSSBuy Spreadsheet, find relevant resources and continue your shopping journey with more organized information.',
  'articles.title': 'Latest Guides & Articles',
  'articles.subtitle': 'Original, in-depth content to help you make better decisions.',
  'article.cssbuyGuide.title': 'CSSBuy Spreadsheet: Complete Guide for Beginners',
  'article.cssbuyGuide.excerpt': 'Learn how to use CSSBuy spreadsheets to find products, compare sellers, and make informed purchasing decisions. This comprehensive guide covers everything from basics to advanced tips.',
  'article.cssbuyGuide.readTime': '8 min read',
  'article.cssbuyGuide.date': 'August 2026',
  'breadcrumb.home': 'Home',
  'breadcrumb.articles': 'Articles',
  'dropdown.allCategories': 'All Categories',
  'dropdown.shoes': 'Shoes',
  'dropdown.hoodies': 'Hoodies/Sweaters',
  'dropdown.tshirts': 'T-Shirts',
  'dropdown.jackets': 'Jackets',
  'dropdown.pants': 'Pants/Shorts',
  'dropdown.headwear': 'Headwear',
  'dropdown.sets': 'Sets',
  'dropdown.underwear': 'Underwear/Underpants',
  'dropdown.jersey': 'Jersey',
  'dropdown.accessories': 'Accessories',
  'dropdown.bags': 'Bags',
  'dropdown.belts': 'Belts',
  'dropdown.perfumes': 'Perfumes',
  'dropdown.other': 'Other Stuff',
};

export default common;